/* cSpell:disable */

import { Platform } from 'react-native';

import { useFeatureFlag } from '@order/LaunchDarkly';
import { checkIfInExpoGoClient, getEnvVars } from '@order/utils';

// ────────────────────────────────────────────────────────────────────────────────

// Feature Flag + Environment Keys + Platform Check
export const useKustomerAvailability = () => {
  const isFeatureFlagEnabled = useFeatureFlag('OPS-kustomer-enabled', {
    listenForChanges: true,
  });

  if (!canEnableKustomer()) return false;

  const { apiKey, brandId } = getKustomerKeys();
  const hasKustomerKeys = Boolean(apiKey && brandId);

  return isFeatureFlagEnabled && hasKustomerKeys;
};

export const getKustomerKeys = () => {
  const { KUSTOMER_API_KEY, KUSTOMER_BRAND_ID } = getEnvVars();
  const apiKey = KUSTOMER_API_KEY;
  const brandId = KUSTOMER_BRAND_ID;

  return { apiKey, brandId };
};

// Kustomer can only be enabled in:
// - web platform.
// - native platforms outside of expo go.
const canEnableKustomer = () => {
  const isWeb = Platform.OS === 'web';
  const isOutsideExpoGo = !checkIfInExpoGoClient();

  return isWeb || isOutsideExpoGo;
};
